import axios from "axios";
import { useEffect, useState } from "react";
import Box from "elements/Box";
import {
  Button,
  Checkbox,
  FormControlLabel,
} from "@mui/material";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import { ProjectConfig } from "Global";
import AlertDialog from "elements/AlertDialog";
import AddIcon from "@mui/icons-material/Add";
import ModeEditIcon from "@mui/icons-material/ModeEdit";
import { useSnackbar } from "notistack";

import { useNavigate, useParams } from "react-router-dom";
import CloudUploadOutlinedIcon from "@mui/icons-material/CloudUploadOutlined";
import AttachFileOutlinedIcon from '@mui/icons-material/AttachFileOutlined';
import ImportPreviewer from "./ImportPreviewer";
import PurchaseOrderPreviewer from "./PurchaseOrderPreviewer";
import { ApiRequest } from "GlobalFunctions";
import AutocompleteField from "elements/AutocompleteField";

export default function SyncForm(props: any) {
  const { setLoading } = props;

  /*SNACKBAR FUNCTION FOR NOTIFICATIONS*/
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  /*============================================= */

  useEffect(() => {
    setLoading(false);
  }, []);

  const defaultValues: any = {
    upload_type: "",
    file: "",
    warehouses: [],
    overwrite_route_order: false,
  };

  const uploadTypeOptions = [
    { value: "products", label: "Productos" },
    { value: "suppliers", label: "Proveedores" },
    { value: "clients", label: "Clientes" },
    { value: "purchases_clients", label: "Proveedores Abastecimiento" },
    { value: "guides", label: "Rutas" },
    { value: "invoices", label: "Cartera" },
    { value: "assets", label: "Activos" },
    { value: "purchase_orders", label: "Órdenes de Compra (XML DIAN)" },
    { value: "picking", label: "Picking" },
  ];

  const [formValues, setFormValues] = useState(defaultValues);
  const [files, setFiles] = useState<any>([]);

  const handleInputChange = (e: { target: { name: any; value: any } }) => {
    const { name, value } = e.target;
    if (name === "upload_type") {
      setFiles([]);
      setFormValues({
        ...formValues,
        upload_type: value,
        file: "",
      });
      return;
    }

    setFormValues({
      ...formValues,
      [name]: value,
    });
  };

  const handleUploadTypeChange = (value: string) => {
    setFiles([]);
    setFormValues({
      ...formValues,
      upload_type: value,
      file: "",
      overwrite_route_order: value === "clients" ? formValues.overwrite_route_order : false,
    });
  };

  /*=======================================
    SUBMIT
  =======================================*/
  const [progress, setProgress] = useState(0);
  const [data, setData] = useState([]);
  const [openViewer, setOpenViewer] = useState(false);
  const [tempXmlPath, setTempXmlPath] = useState('');

  const handleSubmit = async () => {
    setLoading(true);
    console.log(formValues);
    //FILES NEEDS TO BE UPLOADED USING FORMDATA, APART FROM THE OTHER FIELDS
    const formData = new FormData();
    formData.append("files", files);
    formData.append("formValues", JSON.stringify(formValues));

    // Determinar endpoint según tipo de importación
    const endpoint = formValues.upload_type === "purchase_orders"
      ? "/purchaseorders/checkXMLImport"
      : "/sync/checkImportFile";

    await ApiRequest({
      url: endpoint,
      method: "post",
      headers: {
        ltkn: localStorage.getItem("ltkn"),
        delegated_company_id: localStorage.getItem("delegated_company_id") || undefined,
      },
      body: formData,
      setResponse: (response: any) => {
        console.log(response);
        if (response.status === "success") {
          if (formValues.upload_type === "purchase_orders") {
            // Para purchase orders, mostrar preview con información específica
            enqueueSnackbar(`XML cargado correctamente: ${response.preview.invoice_info.line_count} items`, { variant: "success" });
            if (response.preview.warnings && response.preview.warnings.length > 0) {
              response.preview.warnings.forEach((warning: string) => {
                enqueueSnackbar(warning, { variant: "warning" });
              });
            }
            setData(response.preview);
            setTempXmlPath(response.temp_xml_path); // Guardar el path temporal
          } else {
            enqueueSnackbar(`${response.importedQuantity} registros encontrados`, { variant: "success" });
            if (response.nonExistentClients && response.nonExistentClients.length > 0) {
              enqueueSnackbar(`Clientes inexistentes: ${response.nonExistentClients.join(', ')}`, { variant: "warning" });
            }
            setData(response.data);
          }
          setOpenViewer(true);
        } else {
          enqueueSnackbar(response.message || "Error al sincronizar", { variant: "error" });
        }
        setLoading(false);
      },
    });

  };
  /*====================================
  =====================================*/

  return (
    <div id="SupplierList" className="ModuleContainer">
      <div className="ModuleWrapper">
        <div className="boxContainerHeader">
          <div className="boxContainerTitle">
            <h2 className="h2_title">Sincronizar</h2>
            <span className="h2_subtitle">Sube el archivo de acuerdo al tipo de importación</span>
          </div>
          <div className="boxContainerActions"></div>
        </div>

        <Box id="SupplierListIn" className="box100">

        <div>
          <div style={{ marginBottom: "10px", fontWeight: 500 }}>Tipo de importación</div>
          <div style={{ display: "flex", flexWrap: "wrap", gap: "10px" }}>
            {uploadTypeOptions.map((option) => {
              const isSelected = formValues.upload_type === option.value;
              return (
                <Button
                  key={option.value}
                  variant={isSelected ? "contained" : "outlined"}
                  startIcon={<CloudUploadOutlinedIcon />}
                  onClick={() => handleUploadTypeChange(option.value)}
                  sx={{
                    color: isSelected ? "#fff" : "#1e3c47",
                    borderColor: "#1e3c47",
                    backgroundColor: isSelected ? "#1e3c47" : "transparent",
                    "&:hover": {
                      borderColor: "#1e3c47",
                      backgroundColor: isSelected ? "#1e3c47" : "rgba(30, 60, 71, 0.08)",
                    },
                  }}
                >
                  {option.label}
                </Button>
              );
            })}
          </div>
        </div>

        {formValues.upload_type === "products" && (
          <AutocompleteField
            label="Bodegas (opcional)"
            endpoint="/warehouses/list"
            value={formValues.warehouses}
            onChange={(warehouseIds: any) => {
              setFormValues({
                ...formValues,
                warehouses: warehouseIds || []
              });
            }}
            multiple={true}
          />
        )}

        {formValues.upload_type === "clients" && (
          <FormControlLabel
            control={
              <Checkbox
                checked={Boolean(formValues.overwrite_route_order)}
                onChange={(e) => {
                  setFormValues({
                    ...formValues,
                    overwrite_route_order: e.target.checked,
                  });
                }}
              />
            }
            label="Sobrescribir orden de ruta"
            sx={{ mt: 1 }}
          />
        )}


          {formValues.upload_type && (
            <>
              <div
                className={`file_dropzone ${formValues.file && "file_dropzone_active"}`}
                onDrop={(e) => {
                  e.preventDefault();
                  // UPDATE FILE
                  const files = e.dataTransfer.files;
                  setFiles(files[0]);
                  const fileArray = Array.from(files).map((file: any) =>
                    URL.createObjectURL(file)
                  );
                  setFormValues({
                    ...formValues,
                    file: fileArray[0],
                  });
                  e.currentTarget.classList.remove("dropzone_active");
                }}
                onDragOver={(e) => {
                  e.preventDefault();
                  e.currentTarget.classList.add("dropzone_active");
                }}
                onDragLeave={(e) => {
                  e.preventDefault();
                  e.currentTarget.classList.remove("dropzone_active");
                }}
              >
                {formValues.file && <span>{files.name}</span>}

                <label
                  id="dropFileDiv"
                  className={formValues.file && "showOnlyOnHover"}
                >

                    <AttachFileOutlinedIcon />
                    <span>
                      {formValues.upload_type === "purchase_orders"
                        ? "Arrastra o da click para subir un .xml"
                        : "Arrastra o da click para subir un .xlsx"}
                    </span>
                    <input
                      type="file"
                      multiple
                      hidden
                      accept={formValues.upload_type === "purchase_orders" ? ".xml" : ".xlsx"}
                      onChange={(e) => {
                        const files = e.target.files;
                        if (files) {
                          // UPDATE FILE
                          setFiles(files[0]);
                          const fileArray = Array.from(files).map((file: any) =>
                            URL.createObjectURL(file)
                          );
                          setFormValues({
                            ...formValues,
                            file: fileArray[0],
                          });
                        }
                      }}
                    />
                </label>
              </div>

              <Button
                variant="contained"
                color="primary"
                onClick={handleSubmit}
                startIcon={<CloudUploadOutlinedIcon />}
              >
                Subir
              </Button>
            </>
          )}

        </Box>
      </div>

      {formValues.upload_type === "purchase_orders" ? (
        <PurchaseOrderPreviewer
          data={data}
          open={openViewer}
          setOpen={setOpenViewer}
          tempXmlPath={tempXmlPath}
        />
      ) : (
        <ImportPreviewer
          data={data}
          open={openViewer}
          setOpen={setOpenViewer}
          upload_type={formValues.upload_type}
          setLoading={setLoading}
          warehouses={formValues.warehouses}
          overwrite_route_order={formValues.overwrite_route_order}
        />
      )}

    </div>
  );
}
